module.exports = __webpack_public_path__ + "img/excited.5bfce777.svg";